import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Badge,
  Select,
  Stack,
} from '@chakra-ui/react';
import getStatusColor from 'views/Dashboard/DeliveryManagement/utils/StatusColor';
import { useDispatch } from 'react-redux';
import { updateVehicleStatusAction, fetchVehiclesAction } from 'state/actions/vehicleActions';
import { useCustomNotification } from 'components/Toasts/OpenNotification';
import ReusableDrawer from 'components/Drawers/ReusableDrawer';
import ReusableInput from 'components/Inputs/ReusableInput';
import GradientButton from 'components/Buttons/GradientButton';
import headerImage from 'assets/img/background.png';

const EditVehicleDrawer = ({ vehicle, isOpen, onClose }) => {
  const notify = useCustomNotification();
  const dispatch = useDispatch();

  const [status, setStatus] = useState(vehicle?.vehicle?.status || '');
  const [reason, setReason] = useState('');

  useEffect(() => {
    setStatus(vehicle?.vehicle?.status || '');
    setReason('');
  }, [vehicle]);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

 const handleSave = async () => {
  try {
    const response = await dispatch(
      updateVehicleStatusAction(vehicle.vehicle.vehicle_id, status, reason)
    );

    if (response.success) {
      notify({
        message: 'Vehicle Status Updated',
        description: `Status changed to "${status}"`,
        type: 'success',
      });
      onClose();
      dispatch(fetchVehiclesAction());
    } else {
      notify({
        message: 'Failed to Update Status',
        description: response.error || 'An error occurred while updating status.',
        type: 'error',
      });
    }
  } catch (error) {
    notify({
      message: 'Error',
      description: error.message || 'Something went wrong while updating the status.',
      type: 'error',
    });
  }
};


  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerImage={headerImage}
      headerContent={<h2>Edit Vehicle Status</h2>}
      bodyContent={
        <Box>
          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">Current Status</Text>
          <Badge colorScheme={getStatusColor(status)} mb={4} borderRadius="md">
            {status}
          </Badge>

          <Text fontWeight="500" mb={1} fontSize="sm" color="#8D93A1">Update Status</Text>
          <Select
            placeholder="Select status"
            value={status}
            onChange={handleStatusChange}
          >
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Suspended">Suspended</option>
            <option value="Deactivated">Deactivated</option>
            <option value="Rejected">Rejected</option>
          </Select>

          <ReusableInput
            label="Reason for Status Change"
            placeholder="Provide a brief reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            type="textarea"
            mt={4}
          />
        </Box>
      }
      footerContent={
        <Stack direction="row" spacing={4} justifyContent="flex-end">
          <GradientButton onClick={onClose} fontSize="15px" width="100px" height="40px">Cancel</GradientButton>
          <GradientButton onClick={handleSave} fontSize="15px" width="100px" height="40px">Save</GradientButton>
        </Stack>
      }
    />
  );
};

export default EditVehicleDrawer;
